export const trackingSteps = [
  'Order received',
  'Confirmed',
  'Preparing',
  'Packed',
  'On the way',
  'Delivered'
];

export function getTrackingView(order) {
  const status = order.order_status;

  if (order.delivered || status === 'delivered') {
    return {
      index: 5,
      tone: 'delivered',
      headline: 'Delivered',
      message: 'Your order has been delivered. Thank you for choosing ZEVI.'
    };
  }

  if (['cancelled', 'rejected', 'refunded'].includes(status)) {
    return {
      index: -1,
      tone: 'cancelled',
      headline: status === 'refunded' ? 'Refunded' : 'Order cancelled',
      message:
        'This order is no longer active. Please contact ZEVI if you have any questions.'
    };
  }

  const stage = order.fulfilment_stage;

  if (stage === 'ready_for_pickup') {
    return {
      index: 3,
      tone: 'progress',
      headline: 'Ready to be picked up',
      message: 'Your order is ready to be collected from our store.'
    };
  }

  if (stage === 'picked_up') {
    return {
      index: 4,
      tone: 'progress',
      headline: 'Picked up',
      message: 'Your ZEVI has been picked up.'
    };
  }

  if (stage === 'out_for_delivery') {
    return {
      index: 4,
      tone: 'progress',
      headline: 'Out for delivery',
      message: 'Your ZEVI is on its way to you.'
    };
  }

  if (status === 'shipped') {
    return {
      index: 4,
      tone: 'progress',
      headline: 'Out for delivery',
      message: 'Your ZEVI is on its way to you.'
    };
  }

  if (status === 'packed' || stage === 'packed') {
    return {
      index: 3,
      tone: 'progress',
      headline: 'Packed',
      message: 'Your order has been carefully packed and is almost ready to leave.'
    };
  }

  if (status === 'processing') {
    return {
      index: 2,
      tone: 'progress',
      headline: 'Preparing your order',
      message: 'We are preparing your saree with care.'
    };
  }

  if (status === 'confirmed') {
    return {
      index: 1,
      tone: 'progress',
      headline: 'Order confirmed',
      message: 'Your order has been confirmed and will be prepared shortly.'
    };
  }

  if (status === 'awaiting_payment_proof') {
    return {
      index: 0,
      tone: 'progress',
      headline: 'Awaiting payment proof',
      message: 'We are waiting for your payment receipt to confirm the order.'
    };
  }

  if (status === 'payment_review') {
    return {
      index: 0,
      tone: 'progress',
      headline: 'Payment under review',
      message: 'We have received your payment proof and are reviewing it.'
    };
  }

  return {
    index: 0,
    tone: 'progress',
    headline: 'Order received',
    message: 'Your order has been received and is awaiting confirmation.'
  };
}